import React, { useState } from 'react';

import { useDisclosure, useDebouncedValue } from '@mantine/hooks';
import { AthleteRetrieve } from 'types';

import AthleteNotesFilters from './components/AthleteNotesFilters';
import AthleteNotesTable from './components/AthleteNotesTable';
import DrawerNoteForm from './components/DrawerNoteForm';

const Notes = ({
  athlete,
  permission = true,
}: {
  athlete: AthleteRetrieve;
  permission?: boolean;
}): JSX.Element => {
  const [isCreateDrawerOpened, { toggle: handleCreateDrawerToggle }] = useDisclosure(false);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [debouncedSearchTerm] = useDebouncedValue<string>(searchTerm, 250);
  const [noteId, setNoteId] = useState<string | null>(null);

  const handleViewNote = (id: string): void => {
    setNoteId(id);
    handleCreateDrawerToggle();
  };

  return (
    <>
      <AthleteNotesFilters
        openCreateNotes={handleCreateDrawerToggle}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        permission={permission}
      />
      <AthleteNotesTable
        handleViewNote={handleViewNote}
        athleteId={athlete.athleteId}
        searchTerm={debouncedSearchTerm}
        permission={permission}
      />
      <DrawerNoteForm
        opened={isCreateDrawerOpened}
        closeHandler={handleCreateDrawerToggle}
        athleteId={athlete.athleteId}
        noteId={noteId}
        setNoteId={setNoteId}
        permission={permission}
      />
    </>
  );
};

export default Notes;
